import { FC } from 'react'

export const HaveNotPermission: FC = (): JSX.Element => {
  return (
    <div className="-text-bold">
      You do not have permission to access this page.
    </div>
  )
}
